import axios from './axios';
import SETTINGS from '../settings'
export default {
    getNews(params, cb) {
        axios.get(`${SETTINGS.API_BASE_PATH}/news`, {params: params}).then(response => {
            cb(response.data)
        }).catch(e => {
            console.log(e)
        })
    },
    getNewsSingle(id, cb) {
        axios.get(`${SETTINGS.API_BASE_PATH}/news/${id}?_embed=1`).then(response => {
            cb(response.data)
        }).catch(e => {
            console.log(e)
        })
    },
}